/**
 * Registro de paneles embebidos — Trámites Fiscales (servicio central UI).
 */
import ValidacionContribuyentesRfcCurp from "@/pages/laboral/ValidacionContribuyentesRfcCurp";
import InscripcionTrabajadoresSat from "@/pages/InscripcionTrabajadoresSat";
import InscripcionTrabajadoresImss from "@/pages/laboral/InscripcionTrabajadoresImss";
import ValidadorNssImss from "@/pages/laboral/ValidadorNssImss";
import TramitesMaterialidadPage from "@/pages/tramites/TramitesMaterialidadPage";
import { TRAMITES_TAB_IDS } from "@/modules/tramites/manifest";

const PANELS = {
  [TRAMITES_TAB_IDS.VALIDACION_RFC]: ValidacionContribuyentesRfcCurp,
  [TRAMITES_TAB_IDS.INSCRIPCION_SAT]: InscripcionTrabajadoresSat,
  [TRAMITES_TAB_IDS.VALIDADOR_NSS]: ValidadorNssImss,
  [TRAMITES_TAB_IDS.INSCRIPCION_IMSS]: InscripcionTrabajadoresImss,
  [TRAMITES_TAB_IDS.MATERIALIDAD]: TramitesMaterialidadPage,
};

export function resolveTramitesEmbeddedPanel(tabId) {
  return PANELS[tabId] || null;
}

export function TramitesEmbeddedPanel({ tabId }) {
  const Panel = resolveTramitesEmbeddedPanel(tabId);
  if (!Panel) return null;
  return <Panel embedMode="tramites" />;
}
